__turbopack_context__.v({
  "card": "o7p_uG_card",
  "card--placeholder": "o7p_uG_card--placeholder",
  "crests": "o7p_uG_crests",
  "footer": "o7p_uG_footer",
  "poster": "o7p_uG_poster",
  "shimmer": "o7p_uG_shimmer",
  "status": "o7p_uG_status",
  "text-bar-sweep": "o7p_uG_text-bar-sweep",
  "title": "o7p_uG_title",
  "titleSkeleton": "o7p_uG_titleSkeleton",
  "tournamentBadge": "o7p_uG_tournamentBadge",
  "tournamentBadge__name": "o7p_uG_tournamentBadge__name",
});
